import { MembershipRole } from '@/types/api/membership';
import { roleBackgroundColorMapping, roleNameMapping } from '@/utils/membership';

interface MembershipRoleBadgeProps {
  role: MembershipRole;
}

export default function MembershipRoleBadge({ role }: MembershipRoleBadgeProps) {
  return (
    <div className="bg-white rounded-full">
      <div
        className={`ring-background ring-2 text-sm inline-flex font-medium rounded-full text-center px-2.5 py-1 ${roleBackgroundColorMapping[role]}`}
      >
        {roleNameMapping[role]}
      </div>
    </div>
  );
}
